export interface ITaiXiuTable {
  id: string;
  code: string;
  name: string;
  arenaId: string;
  currentMatchDayId?: string;
  currentFightId?: string;
  fightStatus?: string;
  result?: string;
  isAvailable: boolean;
  round: number;
  secondsRemaining: number;
  // `automation_auto_close` on the arena: only then does betting close on a
  // timer, so only then is there a countdown to show.
  autoClose: boolean;
  // `auto_close_timer_sec` on the arena, or the default when it sends none.
  autoCloseSeconds: number;
  // When the open round's betting closes (ms epoch); unset outside one.
  bettingClosesAt?: number;
  minBet: number;
  maxBet: number;
  recentResults: number[];
  recentDice: Array<number[] | undefined>;
  // The round (fight) number of each of `recentResults`, same order, for the road's hover.
  recentRounds?: Array<number | undefined>;
  odds?: { [betType: number]: number };
  // Max stake per selection, by bet type (bet-type-odds `limit`). A bet type
  // with no entry has no limit.
  betLimits?: { [betType: number]: number };
}

// Tai Xiu names for the backend's fight statuses. Values are the raw strings
// the backend sends, so they compare directly against `ITaiXiuTable.fightStatus`.
export enum TaiXiuRoundStatus {
  betOpen = 'confirmed',
  closingSoon = 'closing',
  betClosed = 'closed',
  inPlay = 'started',
  ended = 'ended',
  declared = 'declared',
  // Result dice are known and being revealed on the board.
  revealing = 'processing',
  settled = 'processed',
}

// Statuses that mean the table has a live round (fetched on load/sync).
export const TAI_XIU_CURRENT_ROUND_STATUSES: string[] = [
  TaiXiuRoundStatus.betOpen,
  TaiXiuRoundStatus.closingSoon,
  TaiXiuRoundStatus.betClosed,
  TaiXiuRoundStatus.inPlay,
  TaiXiuRoundStatus.ended,
  TaiXiuRoundStatus.declared,
];

export const TAI_XIU_BET_OPEN_STATUSES: string[] = [TaiXiuRoundStatus.betOpen, TaiXiuRoundStatus.closingSoon];

// Statuses in which the round's result is on the board.
export const TAI_XIU_RESULT_STATUSES: string[] = [
  TaiXiuRoundStatus.revealing,
  TaiXiuRoundStatus.settled,
  TaiXiuRoundStatus.declared,
  TaiXiuRoundStatus.ended,
];
